import React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";

import { useStyles } from "../styles/ProjectTypeCard.styles";

const ProjectTypeCard = ({ children, projectTypeLogo, projectTypeTitle, onClick }) => {
  const classes = useStyles();

  return (
    <ButtonBase focusRipple className={classes.item} onClick={onClick}>
      <div className={classes.header}>
        <img
          alt={projectTypeTitle}
          className={classes.headerIcon}
          src={projectTypeLogo}
        />
        {projectTypeTitle}
      </div>
      <div className={classes.content}>
        {children}
      </div>
    </ButtonBase>
  );
};

export default ProjectTypeCard;
